import { render, staticRenderFns } from "./KanbanDemo.vue?vue&type=template&id=0e3f9dd9&scoped=true&"
import script from "./KanbanDemo.vue?vue&type=script&lang=ts&"
export * from "./KanbanDemo.vue?vue&type=script&lang=ts&"
import style0 from "./KanbanDemo.vue?vue&type=style&index=0&id=0e3f9dd9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e3f9dd9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VBtnToggle,VCard,VCardText,VCol,VContainer,VDivider,VIcon,VRow,VSnackbar})
